import React from 'react';
import HeaderComponent from './Header';
import InfoComponent from './InfoSection';
import MainInfoComponent from './MainInfoSection';
// import StatComponent from './StatSection';
import ReviewComponent from './ReviewSection';
import styles from '../style.module.scss';
import ScreenComponent from './ScreenSection';
import ContactFormComponent from './ContactUsSection';
import AwardsComponent from './AwardsSection';
import FooterComponent from './Footer';

const MainComponent = (props) => {
  const {
    customerData,
    setCustomerData,
    updateCustomerData,
    validated,
    handleSubmit,
    errorMsg,
    registrationRequest,
    handleLoginSuccess,
    handleLoginError,
  } = props;
  return (
    <div className="pb-1">
      <div className={styles.parentDiv}>
        <HeaderComponent
          handleLoginSuccess={handleLoginSuccess}
          handleLoginError={handleLoginError}
        />
        <InfoComponent />
        {/* <StatComponent /> */}
        <MainInfoComponent />
      </div>
      <ReviewComponent />
      <div className={styles.childDiv}>
        <ScreenComponent />
      </div>
      <ContactFormComponent
        errorMsg={errorMsg}
        customerData={customerData}
        setCustomerData={setCustomerData}
        validated={validated}
        handleSubmit={handleSubmit}
        registrationRequest={registrationRequest}
        updateCustomerData={updateCustomerData}
      />
      <div className={styles.childDiv}>
        <AwardsComponent />
        <FooterComponent />
      </div>
    </div>
  );
};
export default MainComponent;
